import React from "react";
import EmailChild from "./EmailChild";
import WebService from "api/explus-api";

class EmailChildContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            child_id: this.props.match.params.childId,
            photo: "",
            message: "",
            fname: "",
            loading: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.setState({ child_id: this.props.match.params.childId });
        }
    }

    handleChange(event) {
        const target = event.target;
        const name = target.name;
        let value = target.value;

        if (name === "photo") {
            value = event.target.files[0];
            this.setState({ fname: value["name"] });
        } else {
            value = target.value;
        }

        this.setState({ [name]: value });
    }

    handleSubmit(event) {
        event.preventDefault();

        this.setState({ loading: true });

        let fd = new FormData();
        fd.append("photo", this.state.photo);
        fd.append("child_id", this.state.child_id);
        fd.append("message", this.state.message);

        WebService.emailChild(fd).then(() => {
            this.setState({ loading: false });
        });
    }

    render() {
        return (
            <EmailChild
                loading={this.state.loading}
                submit={this.handleSubmit}
                fname={this.state.fname}
                change={this.handleChange}
                body={this.state.messasge}
            />
        );
    }
}

export default EmailChildContainer;
